const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2,
          spacing: 5,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: this.els.slide.elements.length <= 4,
            slides: {
              perView: 4,
              spacing: 10,
            },
          },
        },
        slideChanged: (instance) => {
          const position = instance.track.details.abs
          const maxIndex = instance.track.details.maxIdx + 1
          const movementPercentage = (position / maxIndex) * 100

          this.els?.progress?.element?.style.setProperty(
            '--ProductCarousel_Progress',
            `${movementPercentage}%`,
          )
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
